import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import { Grid, Paper, Typography } from "@mui/material";
import moment, { Moment } from "moment";
import { useState } from "react";
import { CenteredLazyLoading } from "../../../controls/LazyLoading";
import { useDelaysForParetoQuery } from "../hooks/queries/useDelaysForParetoQuery";
import { DelaysParetoGraphic } from "./components/DelaysParetoGraphic";
import { Filters } from "./components/filters/Filters";

const assetTitles: { [key: number]: string } = {
  11: "EAF Delays Pareto",
  12: "LMF Delays Pareto",
  13: "Caster Delays Pareto",
};

export const DelaysParetoPage = ({ assetId }: { assetId: number }) => {
  const [error, setError] = useState("");
  const [filterStartDate, setFilterStartDate] = useState<Moment>(
    moment().startOf("day"),
  );
  const [filterEndDate, setFilterEndDate] = useState<Moment>(
    moment().endOf("day"),
  );
  const [includeMicroDelays, setIncludeMicroDelays] = useState(true);
  const [includeUndeclaredDelays, setIncludeUndeclaredDelays] = useState(true);

  const { data: delays = [], isLoading } = useDelaysForParetoQuery(
    {
      startDate: filterStartDate.toDate(),
      endDate: filterEndDate.toDate(),
      delayAreaAssetId: assetId,
      includeMicroDelays,
      includeUndeclaredDelays,
    },
    (err) => setError(err.message),
  );

  const handleFilterChange = (startDate: Moment, endDate: Moment) => {
    setFilterStartDate(startDate);
    setFilterEndDate(endDate);
  };

  const handleIncludeMicroDelaysChange = (include: boolean) => {
    setIncludeMicroDelays(include);
  };

  const handleIncludeUndeclaredDelaysChange = (include: boolean) => {
    setIncludeUndeclaredDelays(include);
  };

  return (
    <>
      <HelmetDexteel title={`${assetTitles[assetId]}`} />
      <Grid container spacing={2} sx={{ p: 2 }}>
        <Grid item xs={12}>
          <Typography variant="h5" sx={{ fontWeight: 600 }}>
            {assetTitles[assetId] || "Delays Pareto Report"}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Paper sx={{ p: 2 }} elevation={2}>
            <Filters
              onFilterChange={handleFilterChange}
              initialStartDate={filterStartDate}
              initialEndDate={filterEndDate}
              includeMicrodelays={includeMicroDelays}
              onIncludeMicrodelaysChange={handleIncludeMicroDelaysChange}
              includeUndeclaredDelays={includeUndeclaredDelays}
              onIncludeUndeclaredDelaysChange={
                handleIncludeUndeclaredDelaysChange
              }
            />
          </Paper>
        </Grid>
        <Grid item xs={12}>
          {isLoading ? (
            <CenteredLazyLoading />
          ) : (
            <DelaysParetoGraphic delays={delays} />
          )}
        </Grid>
      </Grid>

      <ErrorModal error={error} onHide={() => setError("")} />
    </>
  );
};
